export enum PriorityOneActivityName {
  RcnProvidedProfessionalDevelopment = 'RCN Provided Professional Learning',
  StartEventAttendancePlan = 'START Event Attendance',
  EpliPlan = 'EPLI Trainer Plan',
  OtherProfessionalDevelopmentResources = 'Other Professional Learning Resources'
}
